import React, { Component } from 'react';
import { Query } from "react-apollo"
import gql from "graphql-tag"

const parseData = (data) => ({
  ...data,
  seo: JSON.parse(data.seo)
})

export default (getSlugFromProps, getPostType, renderNotFound = () => <h1>Not found</h1>) => WrappedComponent => class WithPost extends Component {
  render() {
    const slug = getSlugFromProps(this.props);
    const endpoint = getPostType(this.props);

    return (
      <Query
        query={gql`
            {
              ${endpoint}By(uri: "${slug}"){
                title
                seo
                slug
                modules {
                  ...on Modules__hero {
                    layout
                    text
                    showOverlay
                    overlayOpacity
                    image {
                      sourceUrl
                    }
                    video {
                      sourceUrl
                    }
                  }

                  ...on Modules__pageHeader {
                    layout
                    image {
                      sourceUrl
                    }
                  }

                  ...on Modules__bodyText {
                    layout
                    body
                    buttons {
                      text
                      layout
                      type
                      externalLink
                      internalLink {
                        ...on Page {
                          link
                        }
                      }
                    }
                  }

                  ...on Modules__quote {
                    layout
                    quote
                    name
                    title
                  }

                  ...on  Modules__gallery {
                    layout
                    items {
                      image {
                        sourceUrl
                      }
                      hasVideo
                      video
                    }
                  }

                  ...on Modules__distance {
                    layout
                    distance
                  }

                  ...on Modules__textAndImage {
                    layout
                    blocks {
                      title
                      text
                      alignment
                      link {
                        url
                        target
                        title
                      }
                      image {
                        sourceUrl
                      }
                    }
                  }

                  ...on Modules__image {
                    layout
                    image {
                      sourceUrl
                      altText
                    }
                  }

                  ...on Modules__focusGrid {
                    layout
                    boxes {
                      title
                      text
                      link
                      image {
                        sourceUrl
                      }
                    }
                  }

                  ...on Modules__video {
                    layout
                    autoplay
                    controls
                    muted
                    loop
                    video {
                      sourceUrl
                    }
                  }

                  ...on Modules__focusDonate {
                    layout
                    title
                    text
                    external
                    link {
                      url
                      target
                      title
                    }
                  }

                  ...on Modules__button {
                    layout
                    external
                    link {
                      url
                      target
                      title
                    }
                  }

                  ...on Modules__contactCards {
                    layout
                    cards {
                      name
                      title
                      text
                      linkedin
                      facebook
                      website
                      image {
                        sourceUrl
                      }
                    }
                  }

                  ...on Modules__form {
                    layout
                    form {
                      FormId
                      title
                      fields
                      submitButtonText
                      confirmations
                    }
                  }
                }
              }
            }`
        }
      >
        {({ loading, error, data }) => (
          <div>
            {!error && ( data[`${endpoint}By`] || loading ) &&
              <WrappedComponent
                {...this.props}
                loading={loading}
                post={data[`${endpoint}By`] && parseData(data[`${endpoint}By`])}
              />
            }
            {(error || (!loading && !data[`${endpoint}By`])) && renderNotFound()}
          </div>
        )}
      </Query>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/withPost.js